export default {
  buy_desc_1: 'Prend en charge plus de 1000 blockchains',
  buy_desc_2: 'Incluant BTC, ETH, TRON, BSC et les chaînes publiques EVM',
  buy_desc_3: 'Un seul appareil pour gérer tous les crypto-actifs',

  features: 'Fonctionnalités',
  features_title_1: 'Puce de sécurité MCU+SE',
  features_desc_1: 'Puce de grade militaire garantissant la sécurité',
  features_title_2: 'Écran LCD 2,0 pouces',
  features_desc_2: 'Plus de détails de transaction ; vous signez ce que vous voyez',
  features_title_3: 'Connexion Bluetooth',
  features_desc_3: 'Communication désensibilisée',
  features_title_4: 'Protections multicouches',
  features_desc_4: 'Hors ligne, code PIN, connexion identifiée',
  color: 'Couleur',
  free_shipping: 'Livraison gratuite',

  break_down_desc_1: 'Bouton GAUCHE',
  break_down_desc_2: 'Aller à gauche à l’écran ou revenir à la page précédente',
  break_down_desc_3: 'Bouton OK',
  break_down_desc_4: 'Confirmer ou entrer dans le menu ; appui long pour allumer/éteindre',
  break_down_desc_5: 'Bouton HAUT',
  break_down_desc_6: 'Aller vers le haut à l’écran',
  break_down_desc_7: 'Bouton DROITE',
  break_down_desc_8: 'Aller vers la droite à l’écran ou confirmer',
  break_down_desc_9: 'Bouton BAS',
  break_down_desc_10: 'Aller vers le bas à l’écran',

  display_title: 'Affichage',
  display_desc: 'Écran LCD 2 pouces',
  battery_title: 'Batterie',
  battery_desc: '100mAh',
  materials_title: 'Matériaux',
  materials_desc: 'Alliage d’aluminium',
  dual_chip_title: 'Double puce',
  dual_chip_desc: 'Puce de sécurité MCU + SE',

  easy_and_safe_title: 'Simple et sécurisé',
  easy_and_safe_desc: 'Connexion et usage faciles, protection sûre des crypto-actifs',
  easy_and_safe_list_1: 'Double puce',
  easy_and_safe_list_2: 'Puce de sécurité MCU + SE',
  easy_and_safe_list_3: 'Connexion facile',
  easy_and_safe_list_4: 'Bluetooth et Type-C',
  easy_and_safe_list_5: 'Écran 2 pouces',
  easy_and_safe_list_6: 'Vous signez ce que vous voyez',

  product_specifications: 'Spécifications du produit',
  detail_center: 'USB Type-C',
  detail_left_1: 'Coque en alliage d’aluminium Protège le portefeuille des dommages',
  detail_left_2: 'Bouton GAUCHE',
  detail_left_3: 'Bouton BAS',
  detail_right_1: 'Écran 2 pouces Pour afficher la transaction associée',
  detail_right_2: 'Bouton HAUT',
  detail_right_3: 'Bouton DROITE',
  detail_right_4: 'Bouton OK',

  keypal_card_1: 'Dimensions',
  keypal_card_label_1: '91mm*55mm*6.7mm',
  keypal_card_2: 'Alimentation et batterie',
  keypal_card_label_2: 'Batterie Li-ion 100mAh',
  keypal_card_3: 'Connexion',
  keypal_card_label_3: 'Bluetooth & Type-C',
  keypal_card_4: 'Matériaux',
  keypal_card_label_4: 'Alliage d’aluminium, plastique',
  keypal_card_5: 'Poids',
  keypal_card_label_5: '53g',
  keypal_card_6: 'Affichage',
  keypal_card_label_6: 'Écran LCD 2 pouces',
  keypal_card_7: 'Puce',
  keypal_card_label_7: 'MCU+SE',
  keypal_card_8: 'Certifications',
  keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

  package: 'Contenu du coffret',
  package_line_1: '1 portefeuille matériel',
  package_line_2: '1 câble USB Type-C',
  package_line_3: '2 fiches de récupération',
  package_line_4: '1 autocollant',

  keypal_plus: {
    larger_battery: 'Capacité de batterie augmentée de 200 %',

    keypal_card_1: 'Dimensions',
    keypal_card_label_1: '91mm*55mm*9.0mm',
    keypal_card_2: 'Alimentation et batterie',
    keypal_card_label_2: 'Batterie Li-ion 300mAh',
    keypal_card_3: 'Connexion',
    keypal_card_label_3: 'Bluetooth & Type-C',
    keypal_card_4: 'Matériaux',
    keypal_card_label_4: 'Alliage d’aluminium, plastique',
    keypal_card_5: 'Poids',
    keypal_card_label_5: '63g',
    keypal_card_6: 'Affichage',
    keypal_card_label_6: 'Écran LCD 2 pouces',
    keypal_card_7: 'Puce',
    keypal_card_label_7: 'MCU+SE',
    keypal_card_8: 'Certifications',
    keypal_card_label_8: 'DOE CEC BEC CE FCC RoHS',

    color: 'Couleur',
    color_desc: 'Noir, Argent, Or',
    battery: 'Batterie',
    battery_desc: '300 mAh',
    left: 'Gauche',
    down: 'Bas',
    right: 'Droite',
    up: 'Haut',
    ok: 'OK',
    center: 'USB Type-C',
    left_1: 'Bouton GAUCHE',
    left_2: 'Aller à gauche à l’écran ou revenir en arrière',
    left_3: 'Bouton BAS',
    left_4: 'Aller vers le bas à l’écran',
    right_1: 'Bouton HAUT',
    right_2: 'Aller vers le haut à l’écran',
    right_3: 'Bouton DROITE',
    right_4: 'Aller vers la droite à l’écran ou confirmer',
    right_5: 'Bouton OK',
    right_6: 'Confirmer ou entrer dans le menu ; appui long pour allumer/éteindre',
    mobile_center: 'Type-C',
    mobile_center_2: 'Pour la charge et la mise à niveau du firmware',
  },
};
